import baseV3Service from './base/baseV3Service.js';

const getMagicButtons = (config) => {
    return baseV3Service.get("magic-buttons", config);
};
const getMagicButtonTemplates = (config) => {
    return baseV3Service.get("magic-buttons/templates", config);
};
const deleteMagicButton = (id, config) => {
    return baseV3Service.delete(`magic-buttons/${id}`, config);
};
const createMagicButton = (payload, config) => {
    return baseV3Service.post("magic-buttons", payload, config);
};

export { createMagicButton, deleteMagicButton, getMagicButtonTemplates, getMagicButtons };
